/* eslint-disable no-unused-vars, react/display-name, react/prop-types */
import React, { useState } from "react";
import {randomN, isValidN} from "./functions/validN"
import {maxDigits, maxPrimes} from "./constants"


export default ({
  z, setZ, count, setCount
}) => {
  const [digits, setDigits] = useState(10)
  const bgc = z && isValidN(z || "0")? "lightgreen":"salmon"

  const randomZ = () => {
    setZ(randomN(digits))
  }

  return (
    <>
      <div className="row">
        <div className="column" style={{ width: "10em" }}>
          <label htmlFor="zval">
            Input a starting N value ending in 1, 3, 7, or 9:{" "}
            <br></br>
            <br></br>
          </label>
          <textarea id="zval" value={z || ""} onChange={(e) => setZ(e.target.value)} style={{ backgroundColor:bgc, height: "15em", zIndex: 100 }}></textarea>
        </div>
        <div className="column" style={{ width: "10em" }}>
          <label>
            Number of primes requested:{" "}
            <input
              type="number"
              max={maxPrimes}
              value={count || ""}
              onChange={(e) => setCount(e.target.value)}
            ></input>
          </label>
          <hr></hr>
          <label>
            {"I wish to generate a random N value of "}
            <input
              type="number"
              defaultValue={digits}
              min="2"
              max={maxDigits}
              onChange={({target})=>setDigits(target.value)} 
            ></input> 
            {"digits: "}
            <input type="button" value="Do it!" onClick={()=>randomZ()}></input> 
          </label>
        </div>
      </div>
    </>
  );
};
